import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import axios from 'axios';
import MapaCobertura from '../cobertura/MapaCobertura';

// Endpoint Mexico (profile_monkey3) para operaciones de linea
const PROFILE_URL = 'https://skeuoyitdc.execute-api.mx-central-1.amazonaws.com/prod/profile2';
const API_URL = process.env.REACT_APP_API_URL;

async function callProfile(payload) {
  const res = await fetch(PROFILE_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
  const result = await res.json();
  if (result && result.body !== undefined) {
    return typeof result.body === 'string' ? JSON.parse(result.body) : result.body;
  }
  return result;
}

const TABS = [
  { id: 'consulta', label: 'Consulta', icon: '🔍' },
  { id: 'activacion', label: 'Activación', icon: '📱' },
  { id: 'recarga', label: 'Recarga', icon: '🔄' },
  { id: 'cambio_sim', label: 'Cambio de SIM', icon: '📲' },
  { id: 'portabilidad', label: 'Portabilidad', icon: '🔁' },
  { id: 'reportes', label: 'Mis Líneas', icon: '📊' },
  { id: 'cobertura', label: 'Cobertura', icon: '📡' },
  { id: 'guia', label: 'Guía', icon: '📖' },
];

// Endpoint Mexico para consulta de perfil de linea (mismo que la webapp publica)
const CAMBACEO_URL = 'https://skeuoyitdc.execute-api.mx-central-1.amazonaws.com/prod/cambaceo_ofertas';

// Deriva { label, value } de un item del catalogo de ofertas del 80.
// Defensivo: value = nombre a mandar como plan_name; label = texto visible (con precio si existe).
function mapOferta(item) {
  if (typeof item === 'string') {
    const s = item.trim();
    return { label: s, value: s };
  }
  if (!item || typeof item !== 'object') return null;
  const value = (
    item.plan_name || item.name || item.nombre || item.plan ||
    item.idoferta_app || item.offer_name || ''
  ).toString().trim();
  if (!value) return null;
  const precio = (item.precio || item.price || item.amount || item.cost || '').toString().trim();
  const label = precio ? `$${precio} ${value}` : value;
  return { label, value };
}

export default function CRM({ id_vendedor }) {
  const [tab, setTab] = useState('consulta');
  const [ofertas, setOfertas] = useState([]);
  const [cargandoOfertas, setCargandoOfertas] = useState(true);
  // Saldo de bolsa del vendedor (mismo endpoint que la consulta de saldo del Dashboard)
  const [saldo, setSaldo] = useState(null);

  useEffect(() => {
    let activo = true;
    (async () => {
      setCargandoOfertas(true);
      try {
        const resp = await axios.post(`${API_URL}/prod/`, { serv: 'ofertas_v80', app: '1' });
        const arr = Array.isArray(resp.data) ? resp.data : [];
        if (arr.length > 0) console.log('[CRM] oferta_v80 item[0] crudo:', arr[0]);
        const lista = arr.map(mapOferta).filter(Boolean);
        if (activo) setOfertas(lista);
      } catch (e) {
        console.error('[CRM] No se pudo cargar catalogo ofertas_v80:', e);
        if (activo) setOfertas([]);
      } finally {
        if (activo) setCargandoOfertas(false);
      }
    })();
    // Consultar el saldo de bolsa del vendedor (id efectivo que llega por props)
    (async () => {
      try {
        const r = await axios.post(`${API_URL}/prod/saldo`, { id_vendedor, app: '1' });
        const s = r.data?.saldo ?? r.data?.body?.saldo ?? null;
        if (activo) setSaldo(s);
      } catch (e) {
        console.error('[CRM] No se pudo cargar saldo:', e);
      }
    })();
    return () => { activo = false; };
  }, [id_vendedor]);

  return (
    <div style={{ marginTop: 16 }}>
      {/* Encabezado ejecutivo */}
      <div style={{
        background: 'linear-gradient(135deg, #0b3d2e 0%, #1b2938 100%)',
        borderRadius: 16, padding: '20px 22px', color: '#fff', marginBottom: 18,
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 12 }}>
          <div>
            <div style={{ fontSize: 12, opacity: 0.7, letterSpacing: 1, textTransform: 'uppercase' }}>Panel Ejecutivo</div>
            <div style={{ fontSize: 22, fontWeight: 800, marginTop: 2 }}>CRM de Líneas</div>
            <div style={{ fontSize: 13, opacity: 0.8, marginTop: 4 }}>Vendedor #{id_vendedor}</div>
          </div>
          <div style={{ textAlign: 'right', background: 'rgba(255,255,255,0.1)', borderRadius: 12, padding: '10px 14px', minWidth: 110 }}>
            <div style={{ fontSize: 11, opacity: 0.7, textTransform: 'uppercase', letterSpacing: 0.5 }}>Saldo</div>
            <div style={{ fontSize: 22, fontWeight: 800, marginTop: 2 }}>
              {saldo !== null && saldo !== undefined ? `$${saldo}` : '—'}
            </div>
            <div style={{ fontSize: 11, opacity: 0.6 }}>MXN</div>
          </div>
        </div>
      </div>

      {/* Tabs */}
      <div style={{ display: 'flex', gap: 8, overflowX: 'auto', marginBottom: 18, paddingBottom: 4 }}>
        {TABS.map(t => (
          <button key={t.id} onClick={() => setTab(t.id)} style={{
            flex: '0 0 auto', padding: '10px 14px', borderRadius: 12, cursor: 'pointer',
            border: tab === t.id ? '2px solid #f59e0b' : '1px solid #e2e8f0',
            background: tab === t.id ? '#fffbeb' : '#fff',
            color: '#1b2938', fontWeight: 700, fontSize: 13, whiteSpace: 'nowrap',
          }}>
            <span style={{ marginRight: 6 }}>{t.icon}</span>{t.label}
          </button>
        ))}
      </div>

      {tab === 'consulta' && <Consulta />}
      {tab === 'activacion' && <Activacion id_vendedor={id_vendedor} ofertas={ofertas} cargandoOfertas={cargandoOfertas} />}
      {tab === 'recarga' && <Recarga id_vendedor={id_vendedor} ofertas={ofertas} cargandoOfertas={cargandoOfertas} />}
      {tab === 'cambio_sim' && <CambioSim />}
      {tab === 'portabilidad' && <Portabilidad />}
      {tab === 'reportes' && <Reportes id_vendedor={id_vendedor} />}
      {tab === 'cobertura' && <Cobertura />}
      {tab === 'guia' && <Guia />}

      <div style={{ height: 80 }} />
    </div>
  );
}

// Estilos compartidos
const input = {
  width: '100%', padding: 12, borderRadius: 10, border: '1px solid #cbd5e1',
  fontSize: 14, boxSizing: 'border-box', marginBottom: 10,
};
const card = {
  background: '#fff', borderRadius: 16, padding: 18,
  boxShadow: '0 2px 12px rgba(0,0,0,0.06)',
};
const select = { ...input, background: '#fff', appearance: 'auto' };

// Selector de plan poblado con el catalogo del 80, con fallback a input de texto.
function PlanSelector({ ofertas, cargandoOfertas, value, onChange }) {
  const hayOfertas = Array.isArray(ofertas) && ofertas.length > 0;

  if (cargandoOfertas) {
    return <div style={{ ...input, color: '#9ca3af', display: 'flex', alignItems: 'center' }}>Cargando catálogo de planes…</div>;
  }

  if (hayOfertas) {
    return (
      <select style={select} value={value} onChange={onChange}>
        <option value="">Selecciona un plan…</option>
        {ofertas.map((o, i) => (
          <option key={`${o.value}-${i}`} value={o.value}>{o.label}</option>
        ))}
      </select>
    );
  }

  // Fallback: catalogo vacio o error al cargar -> input manual (no rompe el flujo)
  return (
    <>
      <div style={{ fontSize: 12, color: '#92400e', background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 8, padding: '6px 10px', marginBottom: 8 }}>
        Catálogo no disponible por ahora. Escribe el nombre del plan manualmente.
      </div>
      <input style={input} placeholder="Nombre del plan" value={value} onChange={onChange} />
    </>
  );
}
function Resultado({ data }) {
  if (!data) return null;
  const ok = data.response === 'ok';
  return (
    <div style={{
      marginTop: 12, padding: 12, borderRadius: 10,
      background: ok ? '#dcfce7' : '#fee2e2', fontSize: 13, color: '#1f2937', wordBreak: 'break-word',
    }}>
      <strong>{ok ? '✅ Operación exitosa' : '❌ No se completó'}</strong>
      {data.detalle && <div style={{ marginTop: 6, fontSize: 12, color: '#6b7280' }}>{String(data.detalle).slice(0, 300)}</div>}
    </div>
  );
}

// ---- CONSULTA (solo info de la linea, sin banana ni ofertas de compra) ----
function Consulta() {
  const [numero, setNumero] = useState('');
  const [cargando, setCargando] = useState(false);
  const [data, setData] = useState(null);

  const consultar = async () => {
    const n = numero.trim();
    if (!/^\d{10}$/.test(n)) { toast.warn('Ingresa un número válido de 10 dígitos'); return; }
    setCargando(true); setData(null);
    try {
      const resp = await axios.post(CAMBACEO_URL, { msisdn: n, name: '', app: '1', serv: 'profile' });
      setData(resp.data || null);
    } catch (e) {
      console.error(e);
      toast.error('No se pudo consultar la línea');
    } finally { setCargando(false); }
  };

  // Dias restantes a partir de fecha_vencimiento (formato dd-mm-aaaa)
  let diasRestantes = null;
  if (data?.fecha_vencimiento) {
    const m = String(data.fecha_vencimiento).match(/(\d{2})-(\d{2})-(\d{4})/);
    if (m) {
      const fv = new Date(`${m[3]}-${m[2]}-${m[1]}`);
      diasRestantes = Math.ceil((fv - new Date()) / (1000 * 60 * 60 * 24));
    }
  }
  const urgente = diasRestantes !== null && diasRestantes <= 3;
  const activa = data && /activ/i.test(String(data.estatus || ''));

  return (
    <div style={card}>
      <h3 style={{ marginTop: 0 }}>🔍 Consulta de línea</h3>
      <input style={input} type="tel" maxLength={10} placeholder="Número (10 dígitos)" value={numero}
        onChange={(e) => setNumero(e.target.value)} />
      <button onClick={consultar} disabled={cargando} className="orange-button" style={{ width: '100%' }}>
        {cargando ? '⏳ Consultando...' : '🔍 Consultar'}
      </button>

      {data && (
        <div style={{ marginTop: 14 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 10 }}>
            <span style={{ fontSize: 16, fontWeight: 700, color: '#1b2938' }}>📞 {data.msisdn || numero}</span>
            <span style={{
              fontSize: 11, fontWeight: 700, padding: '3px 10px', borderRadius: 20,
              background: activa ? '#dcfce7' : '#fee2e2', color: activa ? '#166534' : '#991b1b',
            }}>{data.estatus || 'N/D'}</span>
          </div>

          {data.fecha_vencimiento && (
            <div style={{
              fontSize: 13, marginBottom: 12, padding: '10px 12px', borderRadius: 10,
              background: urgente ? '#fef2f2' : '#f8fafc',
              borderLeft: urgente ? '4px solid #ef4444' : '4px solid #cbd5e1',
            }}>
              <span style={{ color: '#6b7280' }}>📅 Vence: {data.fecha_vencimiento}</span>
              {diasRestantes !== null && (
                <span style={{ marginLeft: 8, fontWeight: 700, color: urgente ? '#ef4444' : '#0b3d2e' }}>
                  ({diasRestantes} día{diasRestantes !== 1 ? 's' : ''})
                </span>
              )}
            </div>
          )}

          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 10 }}>
            {data.datos !== undefined && (
              <div style={{ background: '#eff6ff', borderRadius: 12, padding: 14, textAlign: 'center' }}>
                <div style={{ fontSize: 20, fontWeight: 800, color: '#1b2938' }}>{data.datos}</div>
                <div style={{ fontSize: 12, color: '#4b5563' }}>GB datos</div>
              </div>
            )}
            {(data.min !== undefined || data.llamadas !== undefined) && (
              <div style={{ background: '#dcfce7', borderRadius: 12, padding: 14, textAlign: 'center' }}>
                <div style={{ fontSize: 20, fontWeight: 800, color: '#166534' }}>{data.min !== undefined ? data.min : data.llamadas}</div>
                <div style={{ fontSize: 12, color: '#4b5563' }}>Minutos</div>
              </div>
            )}
            {data.sms !== undefined && (
              <div style={{ background: '#fef3c7', borderRadius: 12, padding: 14, textAlign: 'center' }}>
                <div style={{ fontSize: 20, fontWeight: 800, color: '#92400e' }}>{data.sms}</div>
                <div style={{ fontSize: 12, color: '#4b5563' }}>SMS</div>
              </div>
            )}
          </div>

          {(data.iccid || data.sim_type) && (
            <div style={{ marginTop: 12, fontSize: 12, color: '#6b7280', background: '#f8fafc', borderRadius: 10, padding: '10px 12px' }}>
              {data.iccid && <div><strong>ICCID:</strong> {data.iccid}</div>}
              {data.sim_type && <div><strong>Tipo SIM:</strong> {data.sim_type}</div>}
              {data.portability_status && <div><strong>Portabilidad:</strong> {data.portability_status}</div>}
            </div>
          )}
        </div>
      )}
    </div>
  );
}

// ---- ACTIVACIÓN ----
function Activacion({ id_vendedor, ofertas, cargandoOfertas }) {
  const [f, setF] = useState({ msisdn: '', plan_name: '', name: '', email: '', address: '', contact_phone: '' });
  const [portabilidad, setPortabilidad] = useState(false);
  const [numeroPortar, setNumeroPortar] = useState('');
  const [nip, setNip] = useState('');
  const [cargando, setCargando] = useState(false);
  const [res, setRes] = useState(null);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const enviar = async () => {
    if (!f.msisdn || !f.plan_name) {
      toast.warn('Número y plan son obligatorios');
      return;
    }
    if (portabilidad && (!numeroPortar || !nip)) {
      toast.warn('Para portabilidad ingresa el número a portar y el NIP');
      return;
    }
    setCargando(true); setRes(null);
    try {
      const body = await callProfile({
        msisdn: f.msisdn.trim(), plan_name: f.plan_name.trim(), name: f.name,
        email: f.email || 'no_email', address: f.address, contact_phone: f.contact_phone,
        serv: 'activacion', env: 'prod', id_vendedor,
        // Datos de portabilidad (profile_monkey3 los reenvía a transaccion_mayorista para el 80)
        msisdnPorted: portabilidad ? numeroPortar.trim() : '',
        nip: portabilidad ? nip.trim() : '',
      });
      setRes(body);
      toast[body?.response === 'ok' ? 'success' : 'error'](body?.response === 'ok' ? 'Línea activada' : 'No se pudo activar');
    } catch { toast.error('Error de conexión'); }
    finally { setCargando(false); }
  };

  return (
    <div style={card}>
      <h3 style={{ marginTop: 0 }}>📱 Activación de línea</h3>
      <input style={input} placeholder="Número o ICCID" value={f.msisdn} onChange={set('msisdn')} />
      <PlanSelector ofertas={ofertas} cargandoOfertas={cargandoOfertas} value={f.plan_name} onChange={set('plan_name')} />

      <label style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 14, color: '#1b2938', margin: '4px 0 10px' }}>
        <input type="checkbox" checked={portabilidad} onChange={(e) => setPortabilidad(e.target.checked)} />
        Portabilidad (traer número de otra compañía)
      </label>
      {portabilidad && (
        <div style={{ padding: 14, background: '#f0f4f8', borderRadius: 10, border: '1px dashed #cbd5e1', marginBottom: 10 }}>
          <input style={input} placeholder="Número a portar (10 dígitos)" type="tel" maxLength={10} value={numeroPortar} onChange={(e) => setNumeroPortar(e.target.value)} />
          <input style={{ ...input, marginBottom: 6 }} placeholder="NIP de portabilidad" value={nip} onChange={(e) => setNip(e.target.value)} />
          <div style={{ fontSize: 12, color: '#4b5563', lineHeight: 1.5 }}>
            Marca al <strong>051</strong> desde la línea a portar para recibir tu NIP por SMS.
          </div>
        </div>
      )}

      <button onClick={enviar} disabled={cargando} className="orange-button" style={{ width: '100%' }}>
        {cargando ? '⏳ Activando...' : (portabilidad ? '🔁 Activar con portabilidad' : '📱 Activar línea')}
      </button>
      <Resultado data={res} />
    </div>
  );
}

// ---- RECARGA ----
function Recarga({ id_vendedor, ofertas, cargandoOfertas }) {
  const [msisdn, setMsisdn] = useState('');
  const [plan, setPlan] = useState('');
  const [cargando, setCargando] = useState(false);
  const [res, setRes] = useState(null);

  const enviar = async () => {
    if (!msisdn || !plan) { toast.warn('Número y plan son obligatorios'); return; }
    setCargando(true); setRes(null);
    try {
      const body = await callProfile({
        msisdn: msisdn.trim(), plan_name: plan.trim(), serv: 'recarga', env: 'prod', id_vendedor,
      });
      setRes(body);
      toast[body?.response === 'ok' ? 'success' : 'error'](body?.response === 'ok' ? 'Recarga aplicada' : 'No se pudo recargar');
    } catch { toast.error('Error de conexión'); }
    finally { setCargando(false); }
  };

  return (
    <div style={card}>
      <h3 style={{ marginTop: 0 }}>🔄 Recarga de plan</h3>
      <input style={input} placeholder="Número (MSISDN)" value={msisdn} onChange={(e) => setMsisdn(e.target.value)} />
      <PlanSelector ofertas={ofertas} cargandoOfertas={cargandoOfertas} value={plan} onChange={(e) => setPlan(e.target.value)} />
      <button onClick={enviar} disabled={cargando} className="orange-button" style={{ width: '100%' }}>
        {cargando ? '⏳ Recargando...' : '🔄 Aplicar recarga'}
      </button>
      <Resultado data={res} />
    </div>
  );
}

// ---- CAMBIO DE SIM ----
function CambioSim() {
  const [msisdn, setMsisdn] = useState('');
  const [iccid, setIccid] = useState('');
  const [cargando, setCargando] = useState(false);
  const [res, setRes] = useState(null);

  const enviar = async () => {
    if (!msisdn || !iccid) { toast.warn('Número e ICCID son obligatorios'); return; }
    setCargando(true); setRes(null);
    try {
      const body = await callProfile({
        msisdn: msisdn.trim(), iccid_nuevo: iccid.trim(), serv: 'cambio_sim', env: 'prod',
      });
      setRes(body);
      toast[body?.response === 'ok' ? 'success' : 'error'](body?.response === 'ok' ? 'Cambio de SIM exitoso' : 'No se pudo cambiar la SIM');
    } catch { toast.error('Error de conexión'); }
    finally { setCargando(false); }
  };

  return (
    <div style={card}>
      <h3 style={{ marginTop: 0 }}>📲 Cambio de SIM</h3>
      <p style={{ fontSize: 13, color: '#6b7280', marginTop: 0 }}>La nueva SIM debe estar disponible (Idle).</p>
      <input style={input} placeholder="Número (MSISDN)" value={msisdn} onChange={(e) => setMsisdn(e.target.value)} />
      <input style={input} placeholder="ICCID de la nueva SIM" value={iccid} onChange={(e) => setIccid(e.target.value)} />
      <button onClick={enviar} disabled={cargando} className="orange-button" style={{ width: '100%' }}>
        {cargando ? '⏳ Procesando...' : '📲 Realizar cambio de SIM'}
      </button>
      <Resultado data={res} />
    </div>
  );
}

// ---- PORTABILIDAD (estatus) ----
function Portabilidad() {
  const [msisdn, setMsisdn] = useState('');
  const [cargando, setCargando] = useState(false);
  const [ops, setOps] = useState(null);

  const esPort = (m) => /port|ported/i.test(m || '');

  const consultar = async () => {
    if (!msisdn) { toast.warn('Ingresa un número'); return; }
    setCargando(true); setOps(null);
    try {
      const body = await callProfile({ msisdn: msisdn.trim(), serv: 'operaciones', env: 'prod' });
      const lista = Array.isArray(body?.operaciones) ? body.operaciones : [];
      setOps(lista);
      if (lista.length === 0) toast.info('Sin operaciones para este número');
    } catch { toast.error('Error de conexión'); }
    finally { setCargando(false); }
  };

  const portEvents = (ops || []).filter(o => esPort(o.message));

  return (
    <div style={card}>
      <h3 style={{ marginTop: 0 }}>🔁 Estatus de portabilidad</h3>
      <input style={input} placeholder="Número (MSISDN)" value={msisdn} onChange={(e) => setMsisdn(e.target.value)} />
      <button onClick={consultar} disabled={cargando} className="orange-button" style={{ width: '100%' }}>
        {cargando ? '⏳ Consultando...' : '🔁 Consultar estatus'}
      </button>

      {ops && (
        <div style={{ marginTop: 14 }}>
          {portEvents.length > 0 ? (
            <>
              <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 8, fontWeight: 700 }}>Eventos de portabilidad</div>
              {portEvents.map((o, i) => (
                <div key={i} style={{
                  padding: '10px 12px', marginBottom: 8, borderRadius: 10,
                  background: '#eff6ff', border: '1px solid #bfdbfe',
                }}>
                  <div style={{ fontSize: 11, color: '#9ca3af' }}>{o.operation_date}</div>
                  <div style={{ fontSize: 13, color: '#1f2937' }}>{o.message}</div>
                </div>
              ))}
            </>
          ) : (
            <div style={{ padding: 12, background: '#f8fafc', borderRadius: 10, fontSize: 13, color: '#6b7280' }}>
              Sin eventos de portabilidad para este número.
            </div>
          )}
        </div>
      )}
    </div>
  );
}

// Clasifica una operación como 'alta' (activación) o 'recarga'
function tipoOperacion(item) {
  const t = `${item.trans || ''} ${item.tipo || ''}`.toLowerCase();
  if (/recarg|compra|purchase/.test(t)) return 'recarga';
  // "act", "activ", "alta", "port", "nueva" => alta
  if (/\bact|activ|alta|port|nueva/.test(t)) return 'alta';
  // Fallback: mirar la oferta/estatus
  const extra = `${item.oferta || ''} ${item.Estatus || ''}`.toLowerCase();
  if (/recarg/.test(extra)) return 'recarga';
  return 'alta';
}

// ---- REPORTES (mis líneas) con gráficos ----
function Reportes({ id_vendedor }) {
  const [lineas, setLineas] = useState([]);
  const [cargando, setCargando] = useState(false);
  const [cargado, setCargado] = useState(false);
  const [mes, setMes] = useState('todos');

  const cargar = async () => {
    setCargando(true);
    try {
      const data = { idvendedor: id_vendedor, app: '1', id: '140' };
      const response = await axios.post(`${API_URL}/prod/`, data);
      const all = Array.isArray(response.data) ? response.data : [];
      // El backend ya devuelve las lineas del vendedor consultado.
      setLineas(all);
      setCargado(true);
    } catch (e) {
      console.error(e);
      toast.error('Error al cargar reportes');
    } finally { setCargando(false); }
  };

  useEffect(() => { cargar(); /* eslint-disable-next-line */ }, []);

  // Meses disponibles
  const meses = [...new Set(lineas.map(i => (i.fecha ? String(i.fecha).substring(0, 7) : '')).filter(Boolean))].sort().reverse();

  const filtradas = mes === 'todos' ? lineas : lineas.filter(i => i.fecha && String(i.fecha).startsWith(mes));

  const altas = filtradas.filter(i => tipoOperacion(i) === 'alta');
  const recargas = filtradas.filter(i => tipoOperacion(i) === 'recarga');

  // Serie por mes (para gráfico de barras)
  const porMes = {};
  filtradas.forEach(i => {
    const m = i.fecha ? String(i.fecha).substring(0, 7) : 'sin fecha';
    if (!porMes[m]) porMes[m] = { alta: 0, recarga: 0 };
    porMes[m][tipoOperacion(i)]++;
  });
  const mesesOrden = Object.keys(porMes).sort();
  const maxVal = Math.max(1, ...mesesOrden.map(m => porMes[m].alta + porMes[m].recarga));

  const descargarPDF = () => {
    const filas = filtradas.map(i => `
      <tr>
        <td>${i.folioventa || ''}</td>
        <td>${i.fecha || ''}</td>
        <td>${tipoOperacion(i) === 'alta' ? 'Alta' : 'Recarga'}</td>
        <td>${i.oferta || ''}</td>
        <td>${i.msisdn || ''}</td>
        <td>${i.Estatus || ''}</td>
      </tr>`).join('');
    const html = `
      <html><head><meta charset="utf-8"><title>Reporte de líneas</title>
      <style>
        body{font-family:Arial,sans-serif;color:#1f2937;padding:24px;}
        h1{color:#0b3d2e;border-bottom:3px solid #f59e0b;padding-bottom:6px;}
        .resumen{display:flex;gap:16px;margin:16px 0;}
        .box{flex:1;border:1px solid #e5e7eb;border-radius:10px;padding:12px;text-align:center;}
        .box b{font-size:26px;display:block;color:#0b3d2e;}
        table{width:100%;border-collapse:collapse;font-size:12px;margin-top:12px;}
        th{background:#0b3d2e;color:#fff;padding:7px;text-align:left;}
        td{border:1px solid #e5e7eb;padding:6px;}
        tr:nth-child(even) td{background:#f9fafb;}
        .meta{color:#6b7280;font-size:12px;}
      </style></head><body>
        <h1>Reporte de líneas — Vendedor #${id_vendedor}</h1>
        <div class="meta">Periodo: ${mes === 'todos' ? 'Todos los meses' : mes} · Generado: ${new Date().toLocaleString('es-MX')}</div>
        <div class="resumen">
          <div class="box"><b>${filtradas.length}</b>Total</div>
          <div class="box"><b>${altas.length}</b>Altas</div>
          <div class="box"><b>${recargas.length}</b>Recargas</div>
        </div>
        <table>
          <thead><tr><th>Folio</th><th>Fecha</th><th>Tipo</th><th>Oferta</th><th>Número</th><th>Estatus</th></tr></thead>
          <tbody>${filas}</tbody>
        </table>
      </body></html>`;
    const w = window.open('', '_blank');
    if (!w) { toast.warn('Habilita las ventanas emergentes para descargar el PDF'); return; }
    w.document.write(html);
    w.document.close();
    setTimeout(() => { w.focus(); w.print(); }, 400);
  };

  const total = filtradas.length || 1;
  const pctAltas = Math.round((altas.length / total) * 100);
  const pctRecargas = Math.round((recargas.length / total) * 100);

  return (
    <div style={card}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
        <h3 style={{ margin: 0 }}>📊 Reportes</h3>
        <div style={{ display: 'flex', gap: 8 }}>
          <select value={mes} onChange={(e) => setMes(e.target.value)} style={{
            padding: '6px 10px', borderRadius: 8, border: '1px solid #cbd5e1', fontSize: 13,
          }}>
            <option value="todos">Todos los meses</option>
            {meses.map(m => <option key={m} value={m}>{m}</option>)}
          </select>
          <button onClick={cargar} disabled={cargando} style={{
            padding: '6px 10px', borderRadius: 8, border: '1px solid #e2e8f0', background: '#fff', cursor: 'pointer', fontSize: 13,
          }}>{cargando ? '⏳' : '↻'}</button>
          <button onClick={descargarPDF} style={{
            padding: '6px 12px', borderRadius: 8, border: 'none', background: '#0b3d2e', color: '#fff', cursor: 'pointer', fontSize: 13, fontWeight: 700,
          }}>📄 PDF</button>
        </div>
      </div>

      {!cargado && cargando && <div style={{ padding: 16, color: '#9ca3af', textAlign: 'center' }}>Cargando...</div>}

      {cargado && (
        <>
          {/* Tarjetas resumen */}
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 10, margin: '16px 0' }}>
            <div style={{ background: '#eff6ff', borderRadius: 12, padding: 14, textAlign: 'center' }}>
              <div style={{ fontSize: 24, fontWeight: 800, color: '#1b2938' }}>{filtradas.length}</div>
              <div style={{ fontSize: 12, color: '#4b5563' }}>Total</div>
            </div>
            <div style={{ background: '#dcfce7', borderRadius: 12, padding: 14, textAlign: 'center' }}>
              <div style={{ fontSize: 24, fontWeight: 800, color: '#166534' }}>{altas.length}</div>
              <div style={{ fontSize: 12, color: '#4b5563' }}>Altas</div>
            </div>
            <div style={{ background: '#fef3c7', borderRadius: 12, padding: 14, textAlign: 'center' }}>
              <div style={{ fontSize: 24, fontWeight: 800, color: '#92400e' }}>{recargas.length}</div>
              <div style={{ fontSize: 12, color: '#4b5563' }}>Recargas</div>
            </div>
          </div>

          {/* Gráfico de proporción (barra horizontal) */}
          <div style={{ marginBottom: 18 }}>
            <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 6, fontWeight: 700 }}>Altas vs Recargas</div>
            <div style={{ display: 'flex', height: 26, borderRadius: 8, overflow: 'hidden', background: '#f1f5f9' }}>
              <div style={{ width: `${pctAltas}%`, background: '#16a34a' }} title={`Altas ${pctAltas}%`} />
              <div style={{ width: `${pctRecargas}%`, background: '#f59e0b' }} title={`Recargas ${pctRecargas}%`} />
            </div>
            <div style={{ display: 'flex', justifyContent: 'space-between', fontSize: 11, color: '#6b7280', marginTop: 4 }}>
              <span>🟢 Altas {pctAltas}%</span>
              <span>🟡 Recargas {pctRecargas}%</span>
            </div>
          </div>

          {/* Gráfico de barras por mes */}
          {mesesOrden.length > 0 && (
            <div style={{ marginBottom: 18 }}>
              <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 8, fontWeight: 700 }}>Por mes</div>
              <div style={{ display: 'flex', alignItems: 'flex-end', gap: 10, height: 140, padding: '0 4px', borderBottom: '1px solid #e2e8f0' }}>
                {mesesOrden.map(m => {
                  const a = porMes[m].alta, r = porMes[m].recarga;
                  const hA = Math.round((a / maxVal) * 120);
                  const hR = Math.round((r / maxVal) * 120);
                  return (
                    <div key={m} style={{ flex: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                      <div style={{ display: 'flex', alignItems: 'flex-end', gap: 3, height: 120 }}>
                        <div style={{ width: 14, height: hA, background: '#16a34a', borderRadius: '3px 3px 0 0' }} title={`Altas: ${a}`} />
                        <div style={{ width: 14, height: hR, background: '#f59e0b', borderRadius: '3px 3px 0 0' }} title={`Recargas: ${r}`} />
                      </div>
                      <div style={{ fontSize: 9, color: '#6b7280', marginTop: 4, transform: 'rotate(-30deg)', whiteSpace: 'nowrap' }}>{m}</div>
                    </div>
                  );
                })}
              </div>
              <div style={{ display: 'flex', gap: 14, fontSize: 11, color: '#6b7280', marginTop: 8 }}>
                <span>🟢 Altas</span><span>🟡 Recargas</span>
              </div>
            </div>
          )}

          {cargado && filtradas.length === 0 && (
            <div style={{ padding: 16, color: '#9ca3af', textAlign: 'center' }}>No hay operaciones en el periodo.</div>
          )}

          {/* Lista detalle */}
          <div style={{ maxHeight: 320, overflowY: 'auto' }}>
            {filtradas.map((l, i) => {
              const tipo = tipoOperacion(l);
              return (
                <div key={i} style={{
                  padding: '10px 12px', marginBottom: 8, borderRadius: 10,
                  background: '#f8fafc', border: '1px solid #e2e8f0', fontSize: 12,
                }}>
                  <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                    <span style={{
                      background: tipo === 'alta' ? '#16a34a' : '#f59e0b', color: '#fff',
                      borderRadius: 6, padding: '1px 8px', fontSize: 10, fontWeight: 700,
                    }}>{tipo === 'alta' ? 'ALTA' : 'RECARGA'}</span>
                    <span style={{ color: '#9ca3af' }}>{l.fecha || ''}</span>
                  </div>
                  <div style={{ color: '#1f2937' }}><strong>{l.msisdn || ''}</strong> · {l.oferta || ''}</div>
                  <div style={{ color: '#6b7280' }}>Folio: {l.folioventa || '-'} · {l.Estatus || ''}</div>
                </div>
              );
            })}
          </div>
        </>
      )}
    </div>
  );
}


// ---- COBERTURA ----
function Cobertura() {
  return (
    <div style={card}>
      <h3 style={{ marginTop: 0 }}>📡 Mapa de cobertura</h3>
      <p style={{ fontSize: 13, color: '#6b7280', marginTop: 0 }}>
        Verifica la cobertura MonkeyPhone (red Altán) antes de activar o portar una línea. Arrastra el marcador o navega el mapa.
      </p>
      <MapaCobertura />
      <div style={{ fontSize: 12, color: '#6b7280', marginTop: 10, lineHeight: 1.5 }}>
        Los planes incluyen <strong>roaming en USA y Canadá</strong> sin costo extra.
      </div>
    </div>
  );
}

// ---- GUÍA ----
function Guia() {
  const paso = {
    background: '#f8fafc', border: '1px solid #e2e8f0', borderRadius: 12,
    padding: 14, marginBottom: 12,
  };
  const titulo = { fontWeight: 800, color: '#0b3d2e', fontSize: 14, marginBottom: 6 };
  const txt = { fontSize: 13, color: '#374151', lineHeight: 1.6, margin: 0 };

  return (
    <div style={card}>
      <h3 style={{ marginTop: 0 }}>📖 Guía de uso del CRM</h3>
      <p style={{ fontSize: 13, color: '#6b7280' }}>
        Cómo usar cada herramienta del panel. Todas las operaciones aplican sobre las líneas de tu cuenta.
      </p>

      <div style={paso}>
        <div style={titulo}>📱 Activación</div>
        <p style={txt}>
          Activa una línea nueva. Ingresa el <strong>número o ICCID</strong>, el <strong>nombre del plan</strong>
          (tal cual aparece en el catálogo) y el <strong>nombre del titular</strong>. El correo, dirección y
          teléfono son opcionales. Al terminar verás si la activación fue <strong>exitosa</strong> o no.
        </p>
      </div>

      <div style={paso}>
        <div style={titulo}>🔄 Recarga</div>
        <p style={txt}>
          Aplica un plan a una línea ya activa. Ingresa el <strong>número</strong> y el <strong>nombre del plan</strong>.
          Si la línea no es compatible con el plan o no hay saldo, la respuesta será <strong>no-ok</strong>.
        </p>
      </div>

      <div style={paso}>
        <div style={titulo}>📲 Cambio de SIM</div>
        <p style={txt}>
          Migra un número a una SIM nueva (por pérdida, robo o cambio de equipo). Ingresa el <strong>número</strong>
          y el <strong>ICCID de la SIM nueva</strong>. La SIM nueva debe estar <strong>disponible (Idle)</strong>, sin usar.
        </p>
      </div>

      <div style={paso}>
        <div style={titulo}>🔁 Estatus de portabilidad</div>
        <p style={txt}>
          Consulta el histórico de portabilidad de un número. Ingresa el <strong>número</strong> y verás los eventos
          de portación: <strong>port-in</strong> (entró a la red), <strong>port-out</strong> (salió a otro operador)
          o si está en <strong>proceso</strong>.
        </p>
      </div>

      <div style={paso}>
        <div style={titulo}>📊 Mis Líneas</div>
        <p style={txt}>
          Muestra el reporte de las líneas asociadas a tu cuenta de vendedor. Usa <strong>↻ Actualizar</strong>
          para refrescar la lista.
        </p>
      </div>

      <div style={{ ...paso, background: '#fffbeb', border: '1px solid #fde68a' }}>
        <div style={titulo}>⚠️ Recomendaciones</div>
        <p style={txt}>
          • Usa el <strong>nombre exacto del plan</strong> del catálogo.<br />
          • Los números van a <strong>10 dígitos</strong>, sin espacios ni guiones.<br />
          • Si una activación o recarga sale <strong>exitosa</strong>, no la repitas para evitar cobros dobles.<br />
          • Ante una respuesta incierta, consulta primero <strong>Mis Líneas</strong> antes de reintentar.
        </p>
      </div>
    </div>
  );
}
